import React from 'react';
import { Periods } from '@/creditflowresearch/ui/common/constants';
import HeaderTooltip from '@/creditflowresearch/ui/components/bonds/Charts/ChartTooltip/HeaderTooltip';
import RowTooltip from '@/creditflowresearch/ui/components/bonds/Charts/ChartTooltip/RowTooltip';
import { IPoint } from '@/creditflowresearch/domain/vo/Bond/IChartTooltipData';
import { getGroupList, getTooltipData } from '@/creditflowresearch/ui/components/bonds/Charts/helpers';

interface IProps {
  points: IPoint[],
  period: Periods,
  withPercent: boolean,
}

const ChartTooltip = ({ points, period, withPercent }: IProps) => {
  const toolTipData = getTooltipData(points);
  const groupData = getGroupList(toolTipData, 10);

  return (
    <>
      <HeaderTooltip data={ groupData } period={ period } withPercent={ withPercent } />
      { groupData.map((item) => (
        <RowTooltip
          key={ `${ item.dealCount }-${ item.dealSize }` }
          item={ item }
          withPercent={ withPercent }
        />
      )) }
    </>
  );
};

export default ChartTooltip;
